var _path, _rect, _rect2, _rect3, _rect4, _circle, _g, _ellipse, _g2, _circle2, _circle3, _ellipse2, _ellipse3, _circle4, _circle5, _circle6, _circle7, _path2, _path3, _ellipse4, _circle8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78381 3.08195C9.78381 1.93212 10.7159 1 11.8658 1H12.9067C14.0566 1 14.9887 1.93212 14.9887 3.08195V3.08195C14.9887 3.3694 14.7557 3.60243 14.4682 3.60243H10.3043C10.0168 3.60243 9.78381 3.3694 9.78381 3.08195V3.08195Z",
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.3459,
    y: 4.25391,
    width: 3.90365,
    height: 1.95182,
    rx: 0.975912,
    transform: "rotate(45 20.3459 4.25391)",
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8851,
    y: 6.55371,
    width: 1.30122,
    height: 1.62633,
    transform: "rotate(45 19.8851 6.55371)",
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 7.01465,
    width: 3.90365,
    height: 1.95182,
    rx: 0.975912,
    transform: "rotate(-45 1.75 7.01465)",
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.04785,
    y: 7.47363,
    width: 1.30122,
    height: 1.6259,
    transform: "rotate(-45 4.04785 7.47363)",
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3856,
    cy: 16.2899,
    r: 11.3856,
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3848 7.07844C17.8735 7.07844 22.3577 9.70212 22.7654 13.0369C22.7799 12.8407 22.7945 12.6527 22.7945 12.4484C22.7945 8.27994 18.1356 4.9043 12.3848 4.9043C6.63394 4.9043 1.97504 8.28811 1.97504 12.4484C1.97504 12.6446 1.97504 12.8407 2.00416 13.0369C2.41181 9.70212 6.91056 7.07844 12.3848 7.07844V7.07844Z",
    fill: "#1A1E23"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.3861,
    cy: 16.291,
    rx: 8.78321,
    ry: 8.78321,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3852 10.2039C16.8448 10.2039 20.4882 13.4573 20.8194 17.5926C20.8312 17.3494 20.8431 17.1163 20.8431 16.8629C20.8431 11.6938 17.0577 7.50781 12.3852 7.50781C7.7126 7.50781 3.92725 11.7039 3.92725 16.8629C3.92725 17.1061 3.92725 17.3494 3.95091 17.5926C4.28213 13.4573 7.93736 10.2039 12.3852 10.2039V10.2039Z",
    fill: "#1A1E23"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3866,
    cy: 9.13303,
    r: 0.650608,
    fill: "#1A1E23"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3866,
    cy: 23.7737,
    r: 0.650608,
    fill: "#1A1E23"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.705,
    cy: 16.4533,
    rx: 0.650608,
    ry: 0.650608,
    transform: "rotate(90 19.705 16.4533)",
    fill: "#1A1E23"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.06668,
    cy: 16.4533,
    rx: 0.650608,
    ry: 0.650608,
    transform: "rotate(90 5.06668 16.4533)",
    fill: "#1A1E23"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5602,
    cy: 21.6289,
    r: 0.650608,
    transform: "rotate(135 17.5602 21.6289)",
    fill: "#1A1E23"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.21021,
    cy: 11.2773,
    r: 0.650608,
    transform: "rotate(135 7.21021 11.2773)",
    fill: "#1A1E23"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.21075,
    cy: 21.6287,
    r: 0.650608,
    transform: "rotate(-135 7.21075 21.6287)",
    fill: "#1A1E23"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5607,
    cy: 11.2791,
    r: 0.650608,
    transform: "rotate(-135 17.5607 11.2791)",
    fill: "#1A1E23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3846 16.6151L12.3846 11.085",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3853 16.6173L15.6384 13.3643",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.3869,
    cy: 16.2909,
    rx: 1.66106,
    ry: 1.66106,
    transform: "rotate(90 12.3869 16.2909)",
    fill: "#1A1E23"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3856,
    cy: 16.292,
    r: 0.711884,
    transform: "rotate(90 12.3856 16.292)",
    fill: "#9C82FA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.10842caa38be62b0f925bd2e523a8a5b.svg";
export { ForwardRef as ReactComponent };